import { MenuItem, MenuItemProps } from '@silverfort/sf-components';
import { LogicalItemsTypes } from './LogicalItemsTypes';
import { isPageHidden } from './isPageHidden';

export type MenuItemConfig = {
    id: string;
    title: string;
    disabled?: boolean;
    earlyAvailability?: boolean;
};

type MenuItemContainerProps = LogicalItemsTypes & {
    parentId: string;
    mainTitle: string;
    icon: MenuItemProps['ItemIcon'];
    menuItems: MenuItemConfig[];
    showOnlyFirstItem?: boolean;
};

export const MenuItemContainer: React.FC<MenuItemContainerProps> = ({
    parentId,
    mainTitle,
    icon,
    userData,
    menuItems,
    showOnlyFirstItem,
    children,
    getTowerMenuHref,
    ...props
}) => {
    const visibleItems = menuItems.filter((item) => !isPageHidden(userData?.user, item.id));
    if (visibleItems.length === 0) return null;

    if (visibleItems.length === 1) {
        const visibleItem = visibleItems[0];
        return (
            <MenuItem
                {...props}
                ItemIcon={icon}
                title={mainTitle}
                id={visibleItem.id}
                href={getTowerMenuHref(visibleItem.id)}
                disabled={visibleItem.disabled}
                earlyAvailability={visibleItem.earlyAvailability}
            />
        );
    }

    return !showOnlyFirstItem ? (
        <MenuItem {...props} id={parentId} ItemIcon={icon} title={mainTitle}>
            {visibleItems.map((item) => (
                <MenuItem
                    key={item.id}
                    id={item.id}
                    href={getTowerMenuHref(item.id)}
                    title={item.title}
                    disabled={item.disabled}
                    earlyAvailability={item.earlyAvailability}
                />
            ))}
        </MenuItem>
    ) : (
        <MenuItem
            {...props}
            ItemIcon={icon}
            title={mainTitle}
            id={menuItems[0].id}
            href={getTowerMenuHref(menuItems[0].id)}
            disabled={menuItems[0].disabled}
            earlyAvailability={menuItems[0].earlyAvailability}
        />
    );
};
